import LastServiceCard from "./LastServiceCard";

const LastServicesList = ({ services, deviceUuid }) => {
  if (!deviceUuid) return null;

  if (services.length === 0) {
    return (
      <div className="empty-state">
        Brak wcześniejszych serwisów dla tego urządzenia
      </div>
    );
  }

  return services.map((service) => (
    <LastServiceCard key={service.uuid} service={service} />
  ));
};

export default LastServicesList;
